import { getRequest } from "../api/apiService";

/**
 * Fetches details of a public asset by its ID from the server.
 * 
 * This function sends a GET request to the server using the provided asset ID to retrieve
 * detailed information about the public asset. If the request is successful, it logs the response
 * and returns the asset data. If an error occurs, it logs the error and throws it for further handling.
 * 
 * @param {string} assetId - The ID of the asset to fetch details for.
 * 
 * @returns {Promise<Object>} A promise that resolves with the asset details.
 * 
 * @throws {Error} Throws an error if the GET request fails.
 */
export const fetchPublicAssetDetails = async (assetId) => {
  try {
    // Send a GET request to fetch the asset details by assetId
    const response = await getRequest(`/public/assets/${assetId}`);
    return response.data; // Assuming the response contains asset details in the 'data' field
  } catch (error) {
    throw error; // Rethrow the error for further handling
  }
};
/**
 * Fetches details of a public container (location) by its ID from the server.
 * 
 * @param {string} locationId - The ID of the location to fetch details for.
 * @returns {Promise<Object>} A promise that resolves with the location details.
 */
export const fetchPublicLocationDetails = async (locationId) => {
  try {
    const response = await getRequest(`/public/locations/${locationId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
